/**
 * Zustand store for managing the Portfolios page UI state.
 */

import { create } from 'zustand';

interface PortfoliosStore {
  selectedPortfolioId: string | null;
  setSelectedPortfolioId: (id: string | null) => void;

  searchQuery: string;
  setSearchQuery: (q: string) => void;

  /**
   * Reset to the default (logged-out) state. Called on logout/login (SHA-71)
   * so a previously-selected portfolio id doesn't leak into the next
   * account's session.
   */
  reset: () => void;
}

export const usePortfoliosStore = create<PortfoliosStore>((set) => ({
  selectedPortfolioId: null,
  setSelectedPortfolioId: (id) => set({ selectedPortfolioId: id }),

  searchQuery: '',
  setSearchQuery: (q) => set({ searchQuery: q }),

  reset: () => set({ selectedPortfolioId: null, searchQuery: '' }),
}));
